import { ArrowRight } from 'lucide-react';
import { StatusLamp } from './StatusLamp.tsx';
import type { LampTone } from './StatusLamp.tsx';
import { cx } from './cx.ts';

/**
 * The route strip — Dispatch Deck's second signature. Renders a
 * request's ingress→route→upstream hops as lamp-lit nodes so an
 * operator reads WHERE something went wrong before reading prose.
 */
export interface RouteNode {
  readonly label: string;
  readonly tone: LampTone;
}

interface Props {
  readonly nodes: readonly RouteNode[];
  readonly className?: string;
  readonly testId?: string;
}

export function RoutePath({ nodes, className, testId }: Props): JSX.Element {
  return (
    <span data-testid={testId} className={cx('inline-flex items-center gap-1', className)}>
      {nodes.map((node, index) => (
        <span key={`${node.label}-${String(index)}`} className="inline-flex items-center gap-1">
          {index > 0 ? <ArrowRight aria-hidden="true" className="h-3 w-3 shrink-0 text-paper-faint" /> : null}
          <span className="inline-flex items-center gap-1.5 rounded border border-line bg-raised px-2 py-0.5 font-mono text-micro text-paper-mid">
            <StatusLamp tone={node.tone} size="sm" />
            {node.label}
          </span>
        </span>
      ))}
    </span>
  );
}
